export enum AnnotationsSettingsVisibleType {
    visible = 1,
    name = 2,
    depth = 3
};